import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3f757860/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ComponentDemo links={{
      React: 'http://react.carbondesignsystem.com/?path=/story/checkbox--checked',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-checkbox--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvcheckbox--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=checkbox'
    }} knobs={{
      Checkbox: ['indeterminate', 'disabled', 'hideLabel']
    }} mdxType="ComponentDemo">
  {`
<fieldset className="bx--fieldset">
  <legend className="bx--label">Checkbox heading</legend>
  <Checkbox defaultChecked labelText="Checkbox label" id="checked" />
</fieldset>`}
    </ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      